import React from 'react';
import Icon from '../../common/Icons';
import {
  buildRestDayListSecondaryLine,
  formatRestDayPatientLabel,
  formatRestDayPeriod,
  getPatientInitials,
  getRestDayDurationPillProps,
  getRestDayStatusPillProps,
  isRestDayInProgress
} from './restDayListDisplay';

export default function RestDayListItem({
  item,
  isViewing,
  copy,
  onOpenMenu,
  onRowActivate
}) {
  const patientName = formatRestDayPatientLabel(item);
  const secondary = buildRestDayListSecondaryLine(item, copy);
  const statusPill = getRestDayStatusPillProps(item.status, copy);
  const durationPill = getRestDayDurationPillProps(item.days_count, copy);
  const periodLabel = formatRestDayPeriod(item);
  const isIssued = item.status === 'ISSUED';
  const inProgress = isRestDayInProgress(item);
  const statusLabel = isIssued ? copy.STATUS_ISSUED : copy.STATUS_CANCELLED;
  const initials = getPatientInitials(patientName);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onRowActivate?.(item);
    }
  };

  return (
    <li
      className={[
        'hd-rest-list__item',
        !isIssued ? 'is-cancelled' : '',
        inProgress ? 'is-in-progress' : '',
        isViewing ? 'is-viewing' : ''
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() => onRowActivate?.(item)}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`${patientName} — ${periodLabel || statusLabel}`}
    >
      <span
        className={`hd-rest-list__dot${isIssued ? ' is-active' : ' is-inactive'}`}
        title={statusLabel}
        aria-hidden
      />
      <span className="hd-rest-list__avatar" aria-hidden>
        {initials}
      </span>
      <div className="hd-rest-list__content">
        <div className="hd-rest-list__primary">
          <span className="hd-rest-list__title">{patientName}</span>
          {periodLabel ? (
            <span className="hd-rest-period-chip" title="Période d'arrêt">
              {periodLabel}
            </span>
          ) : null}
        </div>
        <div className="hd-rest-list__secondary">
          {inProgress ? (
            <span className="hd-rest-in-progress-chip">{copy.IN_PROGRESS_BADGE}</span>
          ) : null}
          {durationPill ? (
            <span className={durationPill.className}>{durationPill.label}</span>
          ) : null}
          <span className={statusPill.className}>{statusPill.label}</span>
          {secondary ? (
            <span className="hd-rest-list__sub" title={secondary}>
              {secondary}
            </span>
          ) : null}
        </div>
      </div>
      <button
        type="button"
        className="hd-rest-list__menu hd-exam-actions-menu__toggle"
        onClick={(event) => {
          event.stopPropagation();
          onOpenMenu(event);
        }}
        aria-label={`Actions pour ${patientName}`}
        title="Actions"
      >
        <Icon name="ellipsis-vertical" size={17} />
      </button>
    </li>
  );
}
